/* eslint func-names: 0, no-useless-concat: 0 */
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { useKonami } from 'react-konami-code';
import Nav from '../components/Nav.js';
import Masthead from '../components/Sustainability/Masthead';
import SubMasthead from '../components/Sustainability/SubMasthead';
import SecondaryNav from '../components/SecondaryNav';
import ModalOverlay from '../components/ModalOverlay';
import SustainabilityMap from '../components/Sustainability/map';
import Footer from '../components/Footer';
import ProgramsResources from "../components/Sustainability/ProgramsResources";
import Disclaimers from '../components/Disclaimers.js';
import Committed from "../components/Sustainability/Committed";
import Perspectives from "../components/Sustainability/Perspectives";
import Highlights from "../components/Sustainability/Highlights";
import 'wicg-inert';
import ScrollToTop from "../libs/scrollToTop";
import Featured from "../components/Sustainability/Headlines";
import Impact from "../components/Sustainability/Impact";


const Sustainability = ({
							uiState,
							isMobile,
							handleEvent,
							resetMap,
							chooseDropdownType,
							mapLoading,
							alreadyShown,
							location,
							results,
							checkForCityOrZip,
							goToAnchor,
							closeExitOverlay,
							addExitClickListeners,
							addVideoClickListeners,
							displayVideoOverlay,
							displayModalOverlay,
							modalOverlay,

						}) => {
	addExitClickListeners();
	addVideoClickListeners();
	const [gridVisible, setGridVisible] = useState(false);
	const [enableScrollGA, setEnableScrollGA] = useState(false);
	const [shouldBeInert, setShouldBeInert] = useState(false);
	const toggleInert = () => {
		setShouldBeInert(!shouldBeInert)
	}

	document.addEventListener('keydown', (e) => {
		if (e.keyCode === 9) {
			// console.log(document.activeElement)
		}
	});

	useEffect(() => {

		// console.log(`To see grid overlay, type ↑ ↑ ↓ ↓ ← → ← → B A inside the browser window`);
		ScrollToTop(setEnableScrollGA)

	}, []); // empty array says only use this effect once

	const title = "Sustainability solutions for the future | Wells Fargo"
	const description = "Through the Institute for Sustainable Finance, we’re supporting our clients’ efforts to develop long-term sustainable solutions for a low-carbon economy."
	const image = "https://welcome.wf.com/impact/images/isf-share.jpg"


	const toggleGrid = () => {
		const grid = document.getElementsByClassName('grid')[0];
		grid.style.display = (!gridVisible) ? 'none' : 'block';
		setGridVisible(!gridVisible)
	}

	const KonamiElement = () => {
		useKonami(toggleGrid, {
			code: [37, 39, 37, 39]
		});
		return <div className="grid" style={{display: gridVisible ? 'block' : 'none'}}/>;
	};

	return (
		<>
			<Helmet>
				<title>{`${title}`}</title>
				<link rel="canonical" href="https://welcome.wf.com/impact/"/>
				<meta name="robots" content={location.search.indexOf('target=district') > -1 ? 'noindex, nofollow' : 'index, follow'}/>
				<meta name="description" content={`${description}`}/>

				<meta property="og:title" content={`${title}`}/>
				<meta property="og:description" content={`${description}`}/>
				<meta property="og:image" content={`${image}`}/>

				<meta name="twitter:title" content={`${title}`}/>
				<meta name="twitter:description" content={`${description}`}/>
				<meta name="twitter:image" content={`${image}`}/>

			</Helmet>
			{/*TODO: isMobile should be passed in from route, not calc'd here */}
			<Nav handleEvent={handleEvent} isNotHomePage={false} activePage="sustainability" isMobile={window.innerWidth < 768} showExternalNav toggleInert={toggleInert} shouldBeInert={shouldBeInert}/>
			{!window.innerWidth < 768 && (
				<SecondaryNav page="Sustainability" shouldBeInert={shouldBeInert} activePage="sustainability"/>
			)}
			<main ref={node => node && (shouldBeInert ? node.setAttribute('inert', '') : (node.removeAttribute('inert')))}>
				<Masthead styles="sustainability" goToAnchor={goToAnchor} displayModalOverlay={displayModalOverlay}/>
				<SubMasthead/>
				<Perspectives displayVideoOverlay={displayVideoOverlay} />
				<Impact
					displayVideoOverlay={displayVideoOverlay}
					displayModalOverlay={displayModalOverlay}
				/>
				<Highlights
					displayModalOverlay={displayModalOverlay}
					addExitClickListeners={addExitClickListeners}
				/>
				<Featured
					displayVideoOverlay={displayVideoOverlay}
					displayModalOverlay={displayModalOverlay}
				/>
				<ProgramsResources/>
				<SustainabilityMap
					uiState={uiState}
					handleEvent={handleEvent}
					resetMap={resetMap}
					chooseDropdownType={chooseDropdownType}
					mapLoading={mapLoading}
					alreadyShown={alreadyShown}
					location={location}
					results={results}
					checkForCityOrZip={checkForCityOrZip}
					isMobile={isMobile}
					enableScrollGA={enableScrollGA}
				/>
				<Committed enableScrollGA={enableScrollGA} />
				<Disclaimers goToAnchor={goToAnchor} route="sustainability" shouldBeInert={shouldBeInert}/>
				 {/*<KonamiElement className="grid"/>*/}
			</main>

			<Footer id="footer" footerStyles="global" shouldBeInert={shouldBeInert} activePage="sustainability" enableScrollGA={enableScrollGA}/>

			<div className="nav-overlay mobile-only" style={{display: 'none'}}/>
			{modalOverlay && modalOverlay.open && (
				<ModalOverlay closeExitOverlay={closeExitOverlay} modalOverlay={modalOverlay}/>
			)}

			{/* Adobe retargeting tag */}
{
	/*
		REMOVE TAG

		<img alt="" src="https://rtd-tm.everesttech.net/upi/?sid=s6cvr4h2qH04B3WUwCOG&cs=1" style={{display: 'none'}}/>
	*/
}

		</>
	);
};

export default withRouter(Sustainability);
